module.exports = __webpack_public_path__ + "img/bjsgxgzc_position_img.60e2cf32.png";